import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'admin',
    redirectTo: 'admin',
    pathMatch: 'full',
  },
  {
    path: 'rm',
    redirectTo: 'rm',
    pathMatch: 'full',
  },
  {
    path: 'employee',
    redirectTo: 'employee',
    pathMatch: 'full',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts